export const HTL_STOCK = 'HTL STOCK'
export const ECO_STOCK = 'ECO STOCK'
export const ADMIN_PANEL = 'ADMIN PANEL'
export const SALES_STATS = 'SALES STATS'
export const TLP_POINT = 'TLP POINT'
export const TRIP_POINT = 'TRIP POINT'
export const NEXEN_POINT = 'NEXEN POINT'
export const HTS_POINT_SYSTEM = 'HTS POINT SYSTEM'
export const STAFF_BENEFIT_ADMIN = 'STAFF BENEFIT ADMIN'
export const REQUISITION_FORM = 'REQUISITION FORM'
export const TYREHUB_POINT = 'TYREHUB TRIP'
export const BATTERY_INCENTIVE_POINT = 'BATTERY INCENTIVE TRIP'
export const MOBIL_NORTH_CHINA_TRIP_POINT = 'MOBIL NORTH CHINA TRIP'
export const COMPANY_MAPPING_ADMIN = 'COMPANY MAPPING ADMIN'
export const FIESTA_POINT = 'FIESTA POINT'
export const CP58 = 'CP58'
export const HTG_INCENTIVE = 'HTG INCENTIVE'
export const HTG_INCENTIVE_ADMIN = 'HTG INCENTIVE ADMIN'
export const WHATSAPP_BROADCAST = 'WHATSAPP BROADCAST'
export const HTL_2026 = 'HTL 2026'
export const SALES_COMMISSION_INCENTIVE = 'SALES COMMISSION INCENTIVE'
export const CNN_POINT = 'CNN POINT'
export const CNN_ADMIN = 'CNN ADMIN'
export const GMN_POINT = 'GMN POINT'
export const GMN_ADMIN = 'GMN ADMIN'
export const LUCKY_DRAW_ADMIN = 'LUCKY DRAW ADMIN'

export const permissions = {
  HTL_STOCK,
  ECO_STOCK,
  ADMIN_PANEL,
  SALES_STATS,
  TLP_POINT,
  TRIP_POINT,
  NEXEN_POINT,
  HTS_POINT_SYSTEM,
  STAFF_BENEFIT_ADMIN,
  REQUISITION_FORM,
  TYREHUB_POINT,
  BATTERY_INCENTIVE_POINT,
  MOBIL_NORTH_CHINA_TRIP_POINT,
  COMPANY_MAPPING_ADMIN,
  FIESTA_POINT,
  CP58,
  HTG_INCENTIVE,
  HTG_INCENTIVE_ADMIN,
  WHATSAPP_BROADCAST,
  HTL_2026,
  SALES_COMMISSION_INCENTIVE,
  CNN_POINT,
  CNN_ADMIN,
  GMN_POINT,
  GMN_ADMIN,
  LUCKY_DRAW_ADMIN,
}
